import { IntlShape } from "react-intl"
import { OptionMetricSelect } from "./interfaces"

export const createOptionsMetricSelect = (
	options: Array<OptionMetricSelect>,
	intl: IntlShape
) => {
	return options
		.filter((option) => option.isVisible)
		.map(({ code, id }) => ({
			code: code,
			name: intl.formatMessage({ id }),
		}))
}

export const PENETRATION_OPTIONS: Array<OptionMetricSelect> = [
	{
		code: "total",
		id:
			"phronesis.transactional.application.commercial.benchmark.penetration.select.total",
		isVisible: true,
	},
	{
		code: "weighted",
		id:
			"phronesis.transactional.application.commercial.benchmark.penetration.select.weighted",
		isVisible: true,
	},
]
